import { DatePicker, Image, Spin, Tooltip } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { CardFixedTop, getFileLiveUrl, momentDate } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import { MOB_ICONS } from "../../utils/data";
import Header from "../header";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
const ClassMonitoring = (props) => {
  const history = useNavigate();
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [staffs, setStaffs] = useState(null);
  const [subjects, setSubjects] = useState({});
  const [selDate, setSelDate] = useState(moment());
  const [classData, setClassData] = useState([]);
  const [timeTableData, setTimeTableData] = useState([]);
  const [classSummary, setClassSummary] = useState([]);
  const [currentHour, setCurrentHour] = useState(1);
  const [hourCount, setHourCount] = useState(null);

  const onViewClick = () => {
    setLoader(true);
    loadClassData();
  };

  const loadClassData = async () => {
    const newData = [];
    const formData = new FormData();
    formData.append("attendance_date", moment(selDate).format("YYYY-MM-DD"));
    formData.append("college_uuid", context.user.college_uuid);

    try {
      const response = await axios.post(
        ServiceUrl.MOB.CLASS_TAKEN_REPORT,
        formData
      );
      if (response.data.status === "1") {
        const dayData = response.data.data;
        if (dayData.length > 0) {
          newData.push(...dayData);
        }
      } else {
        toast.error(response.data.message || "Error");
        setLoader(false);
        return;
      }
    } catch (error) {
      toast.error("An error occurred while fetching data.");
      setLoader(false);
      return;
    }
    loadTodayTimeTableData(selDate, context.user.college_uuid).then((tData) => {
      console.log(tData);
      setTimeTableData(tData);
      setClassData(newData);
      var result = getClassTakenData(newData, tData);
      setClassSummary(result);
      setLoader(false);
    });
  };

  useEffect(() => {
    if (context.user.college_uuid) {
      loadStaffs();
      loadSubjects();
      setHourCount(
        context.settingValue(
          "hour_for_attendance_per_day",
          context.user.college_uuid
        )
      );
    }
  }, [context.user.college_uuid]);

  const loadStaffs = () => {
    setLoader(true);
    var form = new FormData();
    form.append("academic_department", "NOT_NULL");
    form.append("college_uuid", context.user.college_uuid);

    axios.post(ServiceUrl.MOB.LIST_EMPLOYEES, form).then((res) => {
      if (res["data"].status == "1") {
        let cStaffs = {};
        res["data"].data.forEach((item) => {
          cStaffs["staff_" + item.uuid] = item;
        });

        setStaffs(cStaffs);
        setLoader(false);
      } else {
        toast.error(res["data"].message || "Error");
      }
    });
  };

  const loadSubjects = () => {
    axios.post(ServiceUrl.MOB.LIST_SUBJECT).then((res) => {
      if (res) {
        let cSubjects = {};
        res["data"].data.forEach((item) => {
          cSubjects[item.id] = item;
        });
        console.log(cSubjects);
        setSubjects(cSubjects);
      }
      setLoader(false);
    });
  };

  const loadTodayTimeTableData = async (date, college_uuid) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("timetable_date", moment(date).format("YYYY-MM-DD"));
      formData.append("college_uuid", college_uuid);
      axios.post(ServiceUrl.MOB.TIMETABLE_ON_DATE, formData).then((res) => {
        if (res["data"].status == "1") {
          resolve(res["data"].data);
        } else {
          reject(res["data"].message || "Error");
        }
      });
    });
  };

  const getDistinctClasses = (data) => {
    //console.log(data);
    const uniqueCombinations = new Set();

    data.forEach((item) => {
      const attHourPerDay = item.att_hour_per_day || hourCount;
      const combination = `${item.course_uuid}#${attHourPerDay}#${item.programme}#${item.batch}#${item.semester}#${item.section}`;
      uniqueCombinations.add(combination);
    });

    const distinctCombinationsArray = Array.from(uniqueCombinations);

    const distinctProgrammeBatchSemesterSection = distinctCombinationsArray.map(
      (combination) => {
        const [
          course_uuid,
          att_hour_per_day,
          programme,
          batch,
          semester,
          section,
        ] = combination.split("#");
        return {
          course_uuid,
          att_hour_per_day,
          programme,
          batch,
          semester,
          section,
        };
      }
    );

    return distinctProgrammeBatchSemesterSection;
  };

  const getClassTakenData = (classDataInput, timeTableDataInput) => {
    var reportArr = [];
    if (classDataInput.length > 0) {
      var uniqueClasses = getDistinctClasses(classDataInput);
      // Extract unique programme values using Set
      const uniqueProgrammesSet = new Set(
        uniqueClasses.map((item) => item.course_uuid)
      );

      const uniqueProgrammesArray = Array.from(uniqueProgrammesSet);

      uniqueProgrammesArray.forEach((item) => {
        var programmeClasses = uniqueClasses.filter(
          (pClass) => pClass.course_uuid == item
        );

        programmeClasses.forEach((pClass) => {
          var rowData = {
            course_uuid: pClass.course_uuid,
            programme: pClass.programme,
            batch: pClass.batch,
            semester: pClass.semester,
            section: pClass.section,
          };
          var noOfHours = parseInt(
            pClass.att_hour_per_day ? pClass.att_hour_per_day : hourCount
          );
          var hourData = [];
          for (var h = 1; h <= noOfHours; h++) {
            var takenClasses = classDataInput.filter(
              (item) =>
                item.course_uuid == pClass.course_uuid &&
                item.batch == pClass.batch &&
                item.section == pClass.section &&
                parseInt(item.semester) == parseInt(pClass.semester) &&
                parseInt(item[`hour_${h}_value`]) === parseInt(h)
            );

            var timeTableClasses = timeTableDataInput.filter(
              (item) =>
                item.course_uuid == pClass.course_uuid &&
                item.batch == pClass.batch &&
                item.section == pClass.section &&
                item.semester == pClass.semester &&
                parseInt(item.hour_value) == parseInt(h)
            );

            var finalClasses = {};

            if (takenClasses.length == 0 && timeTableClasses.length > 0) {
              timeTableClasses.forEach((item) => {
                finalClasses[`${item.teacher}-${item.subject}`] = {
                  teacher: item.teacher,
                  subject: item.subject,
                  isTaken: false,
                };
              });
            }

            if (takenClasses.length > 0) {
              var allotTeachers =
                takenClasses[0][`hour_${h}_allotted_teacher`] &&
                takenClasses[0][`hour_${h}_allotted_teacher`] !== "0"
                  ? [takenClasses[0][`hour_${h}_allotted_teacher`]]
                  : [];

              var allotSubjects =
                takenClasses[0][`hour_${h}_allotted_subject`] &&
                takenClasses[0][`hour_${h}_allotted_subject`] !== "0"
                  ? [takenClasses[0][`hour_${h}_allotted_subject`]]
                  : [];

              allotTeachers.forEach((item, indexT) => {
                let classKey = `${item}-${allotSubjects[indexT]}`;
                if (!finalClasses[classKey]) {
                  finalClasses[classKey] = {
                    teacher: item,
                    subject: allotSubjects[indexT],
                    isTaken: false,
                  };
                }
              });
            }

            takenClasses.forEach((item) => {
              finalClasses[
                `${item[`hour_${h}_teacher`]}-${item[`hour_${h}_subject`]}`
              ] = {
                teacher: item[`hour_${h}_teacher`],
                subject: item[`hour_${h}_subject`],
                isTaken: true,
              };
            });
            var NoOneClassTaken = true;
            Object.entries(finalClasses).forEach(([key, value], index) => {
              if (value.isTaken) {
                NoOneClassTaken = false;
              }
            });

            hourData.push({
              hour: h,
              classes: finalClasses,
              NoOneClassTaken: NoOneClassTaken,
            });
          }

          rowData["attendance"] = hourData;

          reportArr.push(rowData);
        });
      });
    }
    return reportArr;
  };

  /*   const getReportRows = () => {
    var tables = [];
    if (classData.length > 0) {
      var uniqueClasses = getDistinctClasses(classData);

      // Extract unique programme values using Set
      const uniqueProgrammesSet = new Set(
        uniqueClasses.map((item) => item.programme)
      );

      // Convert Set to an array to get unique programmes
      const uniqueProgrammesArray = Array.from(uniqueProgrammesSet);

      uniqueProgrammesArray.forEach((item) => {
        var programmeClasses = uniqueClasses.filter(
          (pClass) => pClass.programme === item
        );

        var trs = [];
        programmeClasses.forEach((pClass) => {
          trs.push(
            <TableRow key={pClass.course_uuid}>
              <TableCell>{pClass.batch}</TableCell>
              <TableCell>{pClass.semester}</TableCell>
              <TableCell>
                {pClass.section && pClass.section.toUpperCase()}
              </TableCell>
              {staffs &&
                getHourTds(pClass, currentHour).map((hourTd, index) => (
                  <TableCell key={index}>{hourTd}</TableCell>
                ))}
            </TableRow>
          );
        });

        var hourTds = [];
        // Only generate columns for the selected currentHour
        if (programmeClasses.length > 0) {
          for (var h = currentHour; h <= currentHour; h++) {
            hourTds.push(
              <TableCell
                key={h}
                sx={{
                  width:
                    (
                      80 / parseInt(programmeClasses[0].att_hour_per_day)
                    ).toString() + "%",
                }}
              >
                {"Hour " + h}
              </TableCell>
            );
          }
        }

        tables.push(
          <TableContainer key={item} component={Paper} sx={{ marginBottom: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={7}
                    sx={{ fontSize: 15, fontWeight: "bold" }}
                  >
                    {item}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Batch</TableCell>
                  <TableCell>Sem.</TableCell>
                  <TableCell>Sec.</TableCell>
                  {hourTds}
                </TableRow>
              </TableHead>
              <TableBody>{trs}</TableBody>
            </Table>
          </TableContainer>
        );
      });
    }

    return tables;
  };

  const getHourTds = (pClass, currentHour) => {
    console.log("pClass", pClass);
    var hourTds = [];
    var noOfHours = parseInt(
      pClass.att_hour_per_day ? pClass.att_hour_per_day : 0
    );

    // Only process if current hour is within valid range
    if (currentHour <= noOfHours) {
      var takenClasses = classData.filter(
        (item) =>
          item.course_uuid === pClass.course_uuid &&
          item.batch == pClass.batch &&
          item.section == pClass.section &&
          parseInt(item.semester) == parseInt(pClass.semester) &&
          parseInt(item[`hour_${currentHour}_value`]) == parseInt(currentHour)
      );

      var timeTableClasses = timeTableData.filter(
        (item) =>
          item.course_uuid == pClass.course_uuid &&
          item.batch == pClass.batch &&
          item.section == pClass.section &&
          item.semester == pClass.semester &&
          parseInt(item.hour_value) == parseInt(currentHour)
      );

      var finalClasses = {};

      if (takenClasses.length === 0 && timeTableClasses.length > 0) {
        timeTableClasses.forEach((item) => {
          finalClasses[`${item.teacher}-${item.subject}`] = {
            teacher: item.teacher,
            subject: item.subject,
            isTaken: false,
          };
        });
      }

      if (takenClasses.length > 0) {
        var allotTeachers =
          takenClasses[0][`hour_${currentHour}_allotted_teacher`] &&
          takenClasses[0][`hour_${currentHour}_allotted_teacher`] !== "0"
            ? [takenClasses[0][`hour_${currentHour}_allotted_teacher`]]
            : [];

        var allotSubjects =
          takenClasses[0][`hour_${currentHour}_allotted_subject`] &&
          takenClasses[0][`hour_${currentHour}_allotted_subject`] !== "0"
            ? [takenClasses[0][`hour_${currentHour}_allotted_subject`]]
            : [];

        allotTeachers.forEach((item, indexT) => {
          let classKey = `${item}-${allotSubjects[indexT]}`;
          if (!finalClasses[classKey]) {
            finalClasses[classKey] = {
              teacher: item,
              subject: allotSubjects[indexT],
              isTaken: false,
            };
          }
        });
      }

      takenClasses.forEach((item) => {
        finalClasses[
          `${item[`hour_${currentHour}_teacher`]}-${
            item[`hour_${currentHour}_subject`]
          }`
        ] = {
          teacher: item[`hour_${currentHour}_teacher`],
          subject: item[`hour_${currentHour}_subject`],
          isTaken: true,
        };
      });

      var NoOneClassTaken = true;
      Object.entries(finalClasses).forEach(([key, value]) => {
        if (value.isTaken) NoOneClassTaken = false;
      });

      var classRows = [];
      Object.entries(finalClasses).forEach(([key, value], index) => {
        classRows.push(
          <TableRow key={index}>
            <TableCell
              sx={{
                height: 50,
                backgroundColor: value.isTaken
                  ? "#9adb9c"
                  : NoOneClassTaken
                  ? "#fb5775"
                  : "#f9d5dc",
              }}
            >
              <Image
                src={getImage(
                  staffs && staffs[`staff_${value.teacher}`]
                    ? staffs[`staff_${value.teacher}`].emp_profile_photo
                    : ""
                )}
                fallback={MOB_ICONS.NO_PHOTO}
                width={30}
                height={30}
                style={{
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: 10,
                }}
              />
              <Tooltip
                title={
                  subjects[value.subject]
                    ? subjects[value.subject].subject_name
                    : "Subject not found"
                }
                placement="top"
                mouseEnterDelay={0.3}
                mouseLeaveDelay={0.1}
              >
                <span
                  style={{
                    cursor: "pointer",
                    fontWeight: "bold",
                    fontFamily:
                      "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    fontSize: 11,
                    color: "#333",
                  }}
                >
                  {staffs && staffs[`staff_${value.teacher}`]
                    ? staffs[`staff_${value.teacher}`].employee_name
                    : ""}
                </span>
              </Tooltip>
            </TableCell>
          </TableRow>
        );
      });

      if (classRows.length === 0) {
        classRows.push(
          <TableRow>
            <TableCell sx={{ backgroundColor: "#f1da2a" }}>?</TableCell>
          </TableRow>
        );
      }

      hourTds.push(
        <TableCell key={currentHour} sx={{ padding: 0 }}>
          <div
            style={{
              height: "100px",
              overflowY: "auto",
              padding: 0,
            }}
          >
            <Table sx={{ width: "100%", height: "100%", tableLayout: "fixed" }}>
              <TableBody>{classRows}</TableBody>
            </Table>
          </div>
        </TableCell>
      );
    }

    return hourTds;
  };
 */

  //corrected

  /*   const getReportRows = () => {
    var tables = [];
    if (classData.length > 0) {
      var uniqueClasses = getDistinctClasses(classData);

      const uniqueProgrammesSet = new Set(
        uniqueClasses.map((item) => item.programme)
      );
      const uniqueProgrammesArray = Array.from(uniqueProgrammesSet);

      uniqueProgrammesArray.forEach((item) => {
        var programmeClasses = uniqueClasses.filter(
          (pClass) => pClass.programme === item
        );

        var trs = [];
        programmeClasses.forEach((pClass) => {
          trs.push(
            <div key={pClass.course_uuid} className="class-row">
           
              <div className={`hour-header hour-${currentHour}`}>
                {"Hour " + currentHour}
              </div>

          
              <div className="batch-semester-section">
                <div className="batch">{pClass.batch}</div>
                <div className="semester">{pClass.semester}</div>
                <div className="section">
                  {pClass.section && pClass.section.toUpperCase()}
                </div>
              </div>

             
              <div className="employee-name">
                {getHourTds(pClass, currentHour)}
              </div>
            </div>
          );
        });

        tables.push(
          <div key={item} className="programme-container">
            <div className="programme-header">
              <h3>{item}</h3>
            </div>
            <div className="rows-container">{trs}</div>
          </div>
        );
      });
    }

    return tables;
  };

  const getHourTds = (pClass, currentHour) => {
    var hourTds = [];
    var noOfHours = parseInt(
      pClass.att_hour_per_day ? pClass.att_hour_per_day : 0
    );

    if (currentHour <= noOfHours) {
      var takenClasses = classData.filter(
        (item) =>
          item.course_uuid === pClass.course_uuid &&
          item.batch == pClass.batch &&
          item.section == pClass.section &&
          parseInt(item.semester) == parseInt(pClass.semester) &&
          parseInt(item[`hour_${currentHour}_value`]) == parseInt(currentHour)
      );

      var timeTableClasses = timeTableData.filter(
        (item) =>
          item.course_uuid == pClass.course_uuid &&
          item.batch == pClass.batch &&
          item.section == pClass.section &&
          item.semester == pClass.semester &&
          parseInt(item.hour_value) == parseInt(currentHour)
      );

      var finalClasses = {};

      if (takenClasses.length === 0 && timeTableClasses.length > 0) {
        timeTableClasses.forEach((item) => {
          finalClasses[`${item.teacher}-${item.subject}`] = {
            teacher: item.teacher,
            subject: item.subject,
            isTaken: false,
          };
        });
      }

      if (takenClasses.length > 0) {
        var allotTeachers =
          takenClasses[0][`hour_${currentHour}_allotted_teacher`] &&
          takenClasses[0][`hour_${currentHour}_allotted_teacher`] !== "0"
            ? [takenClasses[0][`hour_${currentHour}_allotted_teacher`]]
            : [];

        var allotSubjects =
          takenClasses[0][`hour_${currentHour}_allotted_subject`] &&
          takenClasses[0][`hour_${currentHour}_allotted_subject`] !== "0"
            ? [takenClasses[0][`hour_${currentHour}_allotted_subject`]]
            : [];

        allotTeachers.forEach((item, indexT) => {
          let classKey = `${item}-${allotSubjects[indexT]}`;
          if (!finalClasses[classKey]) {
            finalClasses[classKey] = {
              teacher: item,
              subject: allotSubjects[indexT],
              isTaken: false,
            };
          }
        });
      }

      takenClasses.forEach((item) => {
        finalClasses[
          `${item[`hour_${currentHour}_teacher`]}-${
            item[`hour_${currentHour}_subject`]
          }`
        ] = {
          teacher: item[`hour_${currentHour}_teacher`],
          subject: item[`hour_${currentHour}_subject`],
          isTaken: true,
        };
      });

      var NoOneClassTaken = true;
      Object.entries(finalClasses).forEach(([key, value]) => {
        if (value.isTaken) NoOneClassTaken = false;
      });

      var classRows = [];
      Object.entries(finalClasses).forEach(([key, value], index) => {
        classRows.push(
          <div key={index} className="class-row">
            <div
              className="class-cell"
              style={{
                backgroundColor: value.isTaken
                  ? "#9adb9c"
                  : NoOneClassTaken
                  ? "#fb5775"
                  : "#f9d5dc",
              }}
            >
              <div className="teacher-info">
                <img
                  src={getImage(
                    staffs && staffs[`staff_${value.teacher}`]
                      ? staffs[`staff_${value.teacher}`].emp_profile_photo
                      : ""
                  )}
                  alt="Profile"
                  className="teacher-avatar"
                />
                <div className="teacher-name">
                  <Tooltip
                    title={
                      subjects[value.subject]
                        ? subjects[value.subject].subject_name
                        : "Subject not found"
                    }
                    placement="top"
                    mouseEnterDelay={0.3}
                    mouseLeaveDelay={0.1}
                  >
                    <span className="teacher-text">
                      {staffs && staffs[`staff_${value.teacher}`]
                        ? staffs[`staff_${value.teacher}`].employee_name
                        : ""}
                    </span>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        );
      });

      if (classRows.length === 0) {
        classRows.push(
          <div className="class-row">
            <div className="class-cell" style={{ backgroundColor: "#f1da2a" }}>
              ?
            </div>
          </div>
        );
      }

      hourTds.push(
        <div key={currentHour} className="hour-cell">
          <div className="class-container">{classRows}</div>
        </div>
      );
    }

    return hourTds;
  }; */

  const getReportRows = () => {
    var tables = [];
    if (classData.length > 0) {
      var uniqueClasses = getDistinctClasses(classData);

      // Extract unique programme values
      const uniqueProgrammesSet = new Set(
        uniqueClasses.map((item) => item.programme)
      );
      const uniqueProgrammesArray = Array.from(uniqueProgrammesSet);

      // Display the hour header only once at the top for selected currentHour
      const hourHeader = (
        <div className={`hour-header hour-${currentHour}`}>
          {"Hour " + currentHour}
        </div>
      );

      uniqueProgrammesArray.forEach((item) => {
        var programmeClasses = uniqueClasses.filter(
          (pClass) => pClass.programme === item
        );

        var trs = [];
        programmeClasses.forEach((pClass) => {
          trs.push(
            <div key={pClass.course_uuid} className="class-row">
              {/* Batch, Semester, Section displayed side by side */}
              <div className="batch-semester-section">
                <div className="batch">{`(${pClass.batch}) , Sem - ${
                  pClass.semester
                } , ${
                  pClass.section && pClass.section.toUpperCase()
                } - Sec`}</div>
                {/*   <div className="semester">{pClass.semester}</div>
                <div className="section">
                  {pClass.section && pClass.section.toUpperCase()}
                </div> */}
              </div>

              {/* Employee Name Full Width Display */}
              <div className="employee-name">
                {getHourTds(pClass, currentHour)}
              </div>
            </div>
          );
        });

        tables.push(
          <div key={item} className="programme-container">
            <div className="programme-header">
              <h3>{item}</h3>
            </div>
            {/* Render Hour Header Once */}
            {hourHeader}
            <div className="rows-container">{trs}</div>
          </div>
        );
      });
    }

    return tables;
  };

  const getHourTds = (pClass, currentHour) => {
    var hourTds = [];
    var noOfHours = parseInt(
      pClass.att_hour_per_day ? pClass.att_hour_per_day : hourCount
    );

    if (currentHour <= noOfHours) {
      var takenClasses = classData.filter(
        (item) =>
          item.course_uuid === pClass.course_uuid &&
          item.batch == pClass.batch &&
          item.section == pClass.section &&
          parseInt(item.semester) == parseInt(pClass.semester) &&
          parseInt(item[`hour_${currentHour}_value`]) == parseInt(currentHour)
      );

      var timeTableClasses = timeTableData.filter(
        (item) =>
          item.course_uuid == pClass.course_uuid &&
          item.batch == pClass.batch &&
          item.section == pClass.section &&
          item.semester == pClass.semester &&
          parseInt(item.hour_value) == parseInt(currentHour)
      );

      var finalClasses = {};

      if (takenClasses.length === 0 && timeTableClasses.length > 0) {
        timeTableClasses.forEach((item) => {
          finalClasses[`${item.teacher}-${item.subject}`] = {
            teacher: item.teacher,
            subject: item.subject,
            isTaken: false,
          };
        });
      }

      if (takenClasses.length > 0) {
        var allotTeachers =
          takenClasses[0][`hour_${currentHour}_allotted_teacher`] &&
          takenClasses[0][`hour_${currentHour}_allotted_teacher`] !== "0"
            ? [takenClasses[0][`hour_${currentHour}_allotted_teacher`]]
            : [];

        var allotSubjects =
          takenClasses[0][`hour_${currentHour}_allotted_subject`] &&
          takenClasses[0][`hour_${currentHour}_allotted_subject`] !== "0"
            ? [takenClasses[0][`hour_${currentHour}_allotted_subject`]]
            : [];

        allotTeachers.forEach((item, indexT) => {
          let classKey = `${item}-${allotSubjects[indexT]}`;
          if (!finalClasses[classKey]) {
            finalClasses[classKey] = {
              teacher: item,
              subject: allotSubjects[indexT],
              isTaken: false,
            };
          }
        });
      }

      takenClasses.forEach((item) => {
        finalClasses[
          `${item[`hour_${currentHour}_teacher`]}-${
            item[`hour_${currentHour}_subject`]
          }`
        ] = {
          teacher: item[`hour_${currentHour}_teacher`],
          subject: item[`hour_${currentHour}_subject`],
          isTaken: true,
        };
      });

      var NoOneClassTaken = true;
      Object.entries(finalClasses).forEach(([key, value]) => {
        if (value.isTaken) NoOneClassTaken = false;
      });

      var classRows = [];
      Object.entries(finalClasses).forEach(([key, value], index) => {
        classRows.push(
          <div key={index} className="class-row">
            <div
              className="class-cell"
              style={{
                backgroundColor: value.isTaken
                  ? "#9adb9c"
                  : NoOneClassTaken
                  ? "#fb5775"
                  : "#f9d5dc",
              }}
            >
              <div className="teacher-info">
                {/*   <img
                  src={getImage(
                    staffs && staffs[`staff_${value.teacher}`]
                      ? staffs[`staff_${value.teacher}`].emp_profile_photo
                      : ""
                  )}
                  alt="Profile"
                  className="teacher-avatar"
                /> */}
                <Image
                  src={getImage(
                    staffs && staffs["staff_" + value.teacher.toString()]
                      ? staffs["staff_" + value.teacher.toString()]
                          .emp_profile_photo
                      : ""
                  )}
                  fallback={MOB_ICONS.NO_PHOTO}
                  width={30} // Small profile picture size
                  height={30}
                  style={{
                    borderRadius: "50%", // Makes it round
                    objectFit: "cover", // Ensures the image fits inside the circle
                    marginRight: 10, // Adds spacing between image and name
                  }}
                />
                <div className="teacher-name">
                  <Tooltip
                    title={
                      subjects[value.subject]
                        ? subjects[value.subject].subject_name
                        : "Subject not found"
                    }
                    placement="top"
                    mouseEnterDelay={0.3}
                    mouseLeaveDelay={0.1}
                  >
                    <span className="teacher-text">
                      {staffs && staffs[`staff_${value.teacher}`]
                        ? staffs[`staff_${value.teacher}`].employee_name
                        : ""}
                    </span>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        );
      });

      if (classRows.length === 0) {
        classRows.push(
          <div className="class-row">
            <div className="class-cell" style={{ backgroundColor: "#f1da2a" }}>
              ?
            </div>
          </div>
        );
      }

      hourTds.push(
        <div key={currentHour} className="hour-cell">
          <div className="class-container">{classRows}</div>
        </div>
      );
    }

    return hourTds;
  };

  // Functions to navigate through hours
  const goToPreviousHour = () => {
    if (currentHour > 1) {
      setCurrentHour(currentHour - 1);
    }
  };

  const goToNextHour = () => {
    if (currentHour < 6) {
      setCurrentHour(currentHour + 1); // Assuming 12 hours max
    }
  };
  const getImage = (filePath) => {
    return getFileLiveUrl(filePath);
    /*   return NO_IMAGE; */
  };
  return (
    <>
      <Header backAction={true} title="Class Monitoring" />
      <div className="container py-3">
        <Spin spinning={loader}>
          <Card>
            <Card.Header className="px-3 py-2 bg-light">
              <Row className="align-items-center gx-2">
                {/* Date Picker */}
                <Col xs={6} sm={6} md={3} className="mb-2">
                  <Form.Control
                    type="date"
                    size="sm"
                    className="fw-bold"
                    max={momentDate(new Date(), "YYYY-MM-DD")}
                    value={selDate}
                    onChange={(d) => {
                      setSelDate(d.target.value);
                      setClassData([]);
                    }}
                  />
                </Col>

                {/* View Button */}
                <Col xs={6} sm={3} md={2} className="mb-2">
                  <Button
                    type="button"
                    variant="primary"
                    className="w-100"
                    size="sm"
                    onClick={() => onViewClick()}
                  >
                    <i className="fa-solid fa-search pe-1"></i> View
                  </Button>
                </Col>

                {/* Status Indicators */}
                <Col
                  xs={12}
                  md={7}
                  className="d-flex justify-content-between align-items-center mt-2 mt-md-0"
                  style={{ padding: 0 }}
                >
                  {[
                    { label: "Allotted", bgColor: "#f9d5dc" },
                    { label: "Taken", bgColor: "#9adb9c" },
                    { label: "Unattended", bgColor: "#fb5775" },
                    { label: "UnAssigned", bgColor: "#f1da2a" },
                  ].map(({ label, bgColor }, idx) => (
                    <div
                      key={idx}
                      className="d-flex align-items-center me-2 flex-grow-1"
                      style={{
                        height: "40px",
                        backgroundColor: bgColor,
                        borderRadius: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "12px",
                        fontWeight: "bold",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span className="text-dark">{label}</span>
                    </div>
                  ))}
                </Col>
              </Row>
            </Card.Header>

            <Card.Body className="pt-2">
              <div className="tableFixHead ps-table mt-2 d-flex justify-content-between">
                <Button onClick={goToPreviousHour} disabled={currentHour === 1}>
                  &lt;
                </Button>
                <Button onClick={goToNextHour}>&gt;</Button>
              </div>
              {getReportRows()}
            </Card.Body>
          </Card>
        </Spin>
      </div>
    </>
  );
};

export default ClassMonitoring;
